function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCallSpeakersi = function SvgCallSpeakersi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "m7.044 7.264 6.91-3.476a.802.802 0 0 1 .78.033.8.8 0 0 1 .38.681v14.553a.8.8 0 0 1-1.16.715L7.03 16.286H2.847a.8.8 0 0 1-.8-.8V8.064a.8.8 0 0 1 .8-.8h4.197zm.97 1.304V15l5.502 2.767V5.8L8.013 8.568zm10.543-1.203a6.246 6.246 0 0 1 0 8.828.8.8 0 0 0 0 1.131.8.8 0 0 0 1.131 0 7.85 7.85 0 0 0 0-11.091.8.8 0 1 0-1.131 1.132zm-1.928 1.923a3.58 3.58 0 0 1 0 5.061.8.8 0 1 0 1.131 1.132 5.18 5.18 0 0 0 0-7.325.8.8 0 1 0-1.131 1.132zm-12.98-.424v5.822h2.766V8.864H3.647z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCallSpeakersi);
export default ForwardRef;